import { BulletType, flak, frag } from "~lib/BulletType";

export const bulletTypes: Record<string, BulletType> = {
  cannon: new BulletType({
    id: "cannon",
    name: "Cannon",
    damage: 20,
    cooldown: 40,
    explosionDamageSize: 15,
    explosionTerrainSize: 6,
    powerMultiplier: 1.3,
  }),
  minigun: new BulletType({
    id: "minigun",
    name: "Minigun",
    damage: 8,
    cooldown: 10,
    explosionDamageSize: 8,
    explosionTerrainSize: 2,
    powerMultiplier: 1.5,
    angleVariance: 0.06,
    powerVariance: 0.1,
    tickHook: (self) => {
      self.vx *= 0.99;
    },
  }),
  heavy: new BulletType({
    id: "heavy",
    name: "Heavy",
    damage: 30,
    cooldown: 100,
    explosionDamageSize: 25,
    explosionTerrainSize: 15,
    powerMultiplier: 1.3,
  }),
  flak: new BulletType({
    id: "flak",
    name: "Flak",
    damage: 8,
    cooldown: 60,
    explosionDamageSize: 8,
    explosionTerrainSize: 2,
    powerMultiplier: 1.2,
    spawnHook: (self, engine) => {
      flak(self, engine.bullets, {
        count: 7,
        type: "flak",
      });
    },
    tickHook: (self) => {
      self.vx *= 0.99;
    },
  }),
  frag: new BulletType({
    id: "frag",
    name: "Frag",
    damage: 0,
    cooldown: 90,
    explosionDamageSize: 0,
    explosionTerrainSize: 0,
    powerMultiplier: 1.3,
    explodeHook: (self, engine) => {
      frag(self, engine.bullets, {
        count: Math.floor(Math.random() * 4) + 6,
        type: "flak",
        angleRange: Math.PI / 2,
      });
    },
  }),
  airstrike: new BulletType({
    id: "airstrike",
    name: "Airstrike",
    damage: 0,
    cooldown: 160,
    explosionDamageSize: 0,
    explosionTerrainSize: 0,
    powerMultiplier: 2,
    explodeHook: (self, engine) => {
      for (let i = -1; i < 2; i++) {
        engine.bullets.spawnBullet({
          x: self.x + i * 20,
          y: 0,
          vx: 0,
          vy: 2,
          type: bulletTypes["frag"],
          owner: self.owner,
          parentType: self.type,
        });
      }
    },
  }),
};

export const bulletTypeKeys = Object.keys(bulletTypes);
